<template>
 <div data-app>
  <KTCard v-bind:title="title">
      <template v-slot:body>
        <div class="m-portlet__body">



            <div class="form-group m-form__group row">

              <div class="col-lg-2">
                <label class="col-lg-12 col-form-label">Maç:</label>
                  <div class="col-lg-12">
                    <b-form-select 
                      v-model="match_id" 
                      :options="matches" 
                      value-field="id" 
                      text-field="name"
                    >
                    </b-form-select>
                  </div>
              </div>

              <div class="col-lg-2">
                <label class="col-lg-12 col-form-label">&nbsp;</label>
                  <div class="col-lg-12">
                    <b-button
                      size="sm"
                      variant="primary"
                      @click="showResults(match_id)"
                    >
                    <i class="la la-filter"></i>
                        Filtrele
                    </b-button>
                    &nbsp;
                    <b-button
                      size="sm"
                      variant="success"
                      @click="resetFilters()"
                    >
                    <i class="la la-refresh"></i>
                        Temizle
                    </b-button>
                  </div>
              </div>

             

            </div>
          </div>
        
        <v-spacer></v-spacer>

      <table class="table table-hover table-bordered" id="example">
        <thead>
          <tr>
            <th></th>
            <th>ÜYE veya YAKINI İSİM SOYİSİM</th>
            <th>TC KİMLİK NO</th>
            <th>UYRUK</th>
            <th>ÜYE YAKINLIK DERECESİ</th>
            <th>AÇIKLAMA</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="stat in stats" :key="stat.id">
            <td><v-icon
                  class="la la-eye"
                  data-toggle="m-popover" title="Görüntüle"
                  @click="viewTicket(stat.id)"
                  >
                </v-icon>
            </td>
            <td>{{ stat.passolig.name }} {{ stat.passolig.surname }}</td>
            <td>{{ stat.passolig.document_no }}</td>
            <td>{{ stat.passolig.document_type }}</td>
            <td>{{ stat.passolig.kinship }}</td>
            <td>{{ stat.passolig.user.name }} Ailesi <div v-if="stat.description">, {{ stat.description }}</div> </td>
            
          </tr>
          
        </tbody>
        
      </table>
    
    </template>
  </KTCard>    
</div>  
</template>
   
  <script>
  import KTCard from "@/view/content/Card.vue";
  import 'jquery/dist/jquery.min.js';
  //Datatable Modules
  import "datatables.net-dt/js/dataTables.dataTables"
  import "datatables.net-dt/css/jquery.dataTables.min.css"
  import "datatables.net-buttons/js/dataTables.buttons.js"
  import "datatables.net-buttons/js/buttons.colVis.js"
  import "datatables.net-buttons/js/buttons.flash.js"
  import "datatables.net-buttons/js/buttons.html5.js"
  import "datatables.net-buttons/js/buttons.print.js"

  import JSZip from 'jszip';
  window.JSZip = JSZip;
  
  import $ from 'jquery'; 
  import { GET_TICKETS_REPORT } from "@/core/services/store/tickets.module";
  import { ALL_MATCHES } from "@/core/services/store/matches.module";

  export default {
    data: function() {
          return {
              matches:[],
              match_id: '',
              title: "Bilet Listesi - Yurtiçi Deplasman",
              stats: [],
              tickets: [],
              name: "",
              organizational_units: [],
              organizational_unit_id: "",
              registration_number: "",
              match: [],
              user_created: "",
          }
      },
    
    
    methods: {
      showResults(match_id) {
        $('#example').DataTable().destroy();

          this.$store.dispatch(GET_TICKETS_REPORT, {match_id})
          .then((response) => {
              this.stats = response.data;
              setTimeout(function(){
                
              $('#example').DataTable(
                  {
                      pagingType: 'full_numbers',
                      pageLength: 25,
                      processing: true,
                      dom: 'Bfrtip',
                      filter: true,
                      retrieve: true,
                      searching: false,
                      paging: true,
                      responsive: true,
                      language: { "url": "assets/Turkish.json" },
                      order: [[0, 'asc']],
                      buttons: [
                      {
                          extend: 'copy',
                          text: 'Kopyala',
                          footer: true,
                          className: 'btn btn-success'
                      },
                      {
                          extend: 'excel', // Excel export button
                          text: 'Excel',
                          footer: true,
                          className: 'btn btn-success'
                      },
                      {
                          extend: 'print',
                          text: 'Yazdır',
                          footer: true,
                          className: 'btn btn-success'
                      },
                    ],
                  }
              );
            },
            1000
            );  
          })
      },

      viewTicket(id) {
          this.$router.push({
              name: "tickets-form",
              params: { id: id, formType: "view" }
          });
      },

      resetFilters() {
        this.match_id = "";
        
        $('#example').DataTable().destroy();
        this.stats = [];
      }
    },
    
   
    components: {
       KTCard,
    },

    created() {
      this.$store.dispatch(ALL_MATCHES)
        .then(( response ) => {
            this.matches = response.data;
        })

     
    },

  }
  </script>
  